// extracted by mini-css-extract-plugin
export default {"input":"styles__input___3D531","textarea":"styles__textarea___Pb6R- styles__input___3D531"};